import * as Types from "../Constants/AllConstants";

export const MySmsSubscriptionsReducer = (state = { subscriptions: [] }, action) => {
  switch (action.type) {
    case Types.MY_SMS_SUBSCRIPTIONS_REQUEST:
      return { loading: true };
    case Types.MY_SMS_SUBSCRIPTIONS_SUCCESS:
      return { loading: false, subscriptions: action.payload };
    case Types.MY_SMS_SUBSCRIPTIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const MyEmailSubscriptionsReducer = (state = { subscriptions: [] }, action) => {
  switch (action.type) {
    case Types.MY_EMAIL_SUBSCRIPTIONS_REQUEST:
      return { loading: true };
    case Types.MY_EMAIL_SUBSCRIPTIONS_SUCCESS:
      return { loading: false, subscriptions: action.payload };
    case Types.MY_EMAIL_SUBSCRIPTIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const MyActiveSmsSubscriptionReducer = (state = { subscription: {} }, action) => {
  switch (action.type) {
    case Types.MY_ACTIVE_SMS_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case Types.MY_ACTIVE_SMS_SUBSCRIPTION_SUCCESS:
      return { loading: false, subscription: action.payload };
    case Types.MY_ACTIVE_SMS_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const MyActiveEmailSubscriptionReducer = (state = { subscription: {} }, action) => {
  switch (action.type) {
    case Types.MY_ACTIVE_EMAIL_SUBSCRIPTION_REQUEST:
      return { loading: true };
    case Types.MY_ACTIVE_EMAIL_SUBSCRIPTION_SUCCESS:
      return { loading: false, subscription: action.payload };
    case Types.MY_ACTIVE_EMAIL_SUBSCRIPTION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const RefillSmsCreditsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.REFILL_SMS_CREDITS_REQUEST:
      return { loading: true };
    case Types.REFILL_SMS_CREDITS_SUCCESS:
      return { loading: false, transaction: action.payload, success: true };
    case Types.REFILL_SMS_CREDITS_FAIL:
      return { loading: false, error: action.payload };
    case Types.REFILL_SMS_CREDITS_RESET:
      return {};
    default:
      return state;
  }
};

export const RefillEmailCreditsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.REFILL_EMAIL_CREDITS_REQUEST:
      return { loading: true };
    case Types.REFILL_EMAIL_CREDITS_SUCCESS:
      return { loading: false, transaction: action.payload, success: true };
    case Types.REFILL_EMAIL_CREDITS_FAIL:
      return { loading: false, error: action.payload };
    case Types.REFILL_EMAIL_CREDITS_RESET:
      return {};
    default:
      return state;
  }
};

export const GetRefillPricingReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.GET_REFILL_PRICING_REQUEST:
      return { loading: true };
    case Types.GET_REFILL_PRICING_SUCCESS:
      return { loading: false, pricing: action.payload };
    case Types.GET_REFILL_PRICING_FAIL:
      return { loading: false, error: action.payload };
    case Types.GET_REFILL_PRICING_RESET:
      return {};
    default:
      return state;
  }
};
